import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const OrderSummary = () => {
  const { id } = useParams(); // Retrieve the ID from the route params
  const [order, setOrder] = useState(null); // State to store order details
  const [loading, setLoading] = useState(true); // State for loading indicator
  const [error, setError] = useState(null); // State for error handling

  useEffect(() => {
    // Function to fetch order details by ID
    const fetchOrder = async () => {
      try {
        const response = await axios.get(`https://citi-mobile-app.onrender.com/saleagent/orders/${id}`); // Replace with your API endpoint
        setOrder(response.data.order); // Save the order details in the state
        setLoading(false); // Set loading to false once data is fetched
      } catch (err) {
        setError('Failed to fetch order details');
        setLoading(false);
      }
    };

    fetchOrder(); // Call the fetch function when the component mounts
  }, [id]); // Re-run the effect when the ID changes

  // Display loading spinner if the data is still being fetched
  if (loading) {
    return <div>Loading...</div>;
  }

  // Display error message if there is an issue fetching the data
  if (error) {
    return <div>{error}</div>;
  }

  // Check if the order data exists
  if (!order) {
    return <div>No order found</div>;
  }

  return (
    <div className="flex flex-col lg:flex-row max-sm:mt-16 justify-between max-w-5xl mx-auto sm:p-6 bg-gray-50 max-sm:bg-white">
      {/* Products Section */}
      <div className="w-full lg:w-[45%] bg-white p-4 sm:p-6 mb-6 lg:mb-0 rounded-md shadow-md">
        <h2 className="text-xl font-bold mb-4">Products</h2>
        <div className="grid grid-cols-1 gap-4">
          {order.products.map((product, index) => (
            <div key={index} className="flex items-center">
              <img
                src={product.image}
                alt={product.title}
                className="h-16 w-16 object-cover mr-4"
              />
              <div>
                <p className="font-semibold">{product.title}</p>
                <p className="text-gray-600">${product.price}</p>
                <p className="text-blue-600">Carton: {product.cartonOption}</p>
                <p className="text-blue-600">Quantity: {product.quantity}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Order Summary Section */}
      <div className="w-full lg:w-[45%] bg-white p-4 sm:p-6 rounded-md shadow-md">
        <div className="mb-4">
          <p className="text-gray-600">Customer's Name:</p>
          <p className="font-semibold">{order.fullname}</p>
        </div>

        <div className="mb-4">
          <p className="text-gray-600">Delivery Details:</p>
          <p>Delivery Address: {order.address}</p>
          <p>Delivery to: {order.deliveryTo}</p>
          <p>Phone Number: {order.phoneNumber}</p>
        </div>

        <div className="mb-4">
          <p className="text-gray-600">Total Amount:</p>
          <p className="font-semibold">${order.totalAmount}</p>
        </div>

        <div className="mb-4">
          <p className="text-gray-600">Order Status:</p>
          <span className={`py-1 px-3 rounded-full text-sm ${order.deliverystatus === 'delivered' ? 'bg-green-100 text-green-600' : 'bg-orange-100 text-orange-600'}`}>
            {order.deliverystatus}
          </span>
        </div>

        <div className="mb-4">
          <p className="text-gray-600">Payment Status:</p>
          <span className={`py-1 px-3 rounded-full text-sm ${order.paymentstatus === 'Paid' ? 'bg-green-100 text-green-600' : 'bg-yellow-100 text-yellow-600'}`}>
            {order.paymentstatus}
          </span>
        </div>

        <div className="mb-4">
          <p className="text-gray-600">Date Ordered:</p>
          <span>{new Date(order.date).toLocaleDateString()}</span>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
